import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-container">
      <div className="about-container-sub">
        <div className="about-img-container">
          <img
            className="about-img"
            alt="about"
            src="https://res.cloudinary.com/dsgpdeonk/image/upload/v1623168740/5BCD4364-ED81-41CB-BC30-17976FD0279C_ci8vqo.jpg"
          ></img>
        </div>
        <div className="about-content-container">
          <div className="about-title-wrapper">
            <h1 className="section-title">ABOUT ME</h1>
            <h3 className="section-subtitle">So what's my story?</h3>
          </div>
          <p>
            I'm Erik Hendrikson, currently living in Amsterdam, the Netherlands. I
            graduated from university in notarial law and decided to make a
            career-switch to webdevelopment.
          </p>
          <p>
            When I entered the Codaisseur JavaScript Bootcamp in 2021 it felt
            like coming home. Ever since I'm coding and creating new websites
            and apps on a daily basis. What makes me most happy is creating apps
            that put a smile on your face.
          </p>
          <div className="about-links-container">
            <a href="https://docdro.id/t4gDz0c">
              <button className="cv-button">DOWNLOAD CV</button>
            </a>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/erik-hendrikson-1a9805a0/">
                <div className="social-img-container">
                  <img
                    className="social-img"
                    alt="social"
                    src="https://res.cloudinary.com/dsgpdeonk/image/upload/v1623238630/linkedin_1_rcwwki.svg"
                  ></img>
                </div>
              </a>
              <a href="https://github.com/ErikHendrikson">
                <div className="social-img-container">
                  <img
                    className="social-img"
                    alt="social"
                    src="https://res.cloudinary.com/dsgpdeonk/image/upload/v1623238575/github_jopgp7.svg"
                  ></img>
                </div>
              </a>
              <a href="https://open.spotify.com/user/1160861215?si=a09bd3e904034c39">
                <div className="social-img-container">
                  <img
                    className="social-img"
                    alt="social"
                    src="https://res.cloudinary.com/dsgpdeonk/image/upload/v1623238567/spotify_l8ymxy.svg"
                  ></img>{" "}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
